import React from "react";
import "./Checkout.css";
import checkout from "assets/check.jpg";
import {
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeCheckoutForm from "./StripeCheckoutForm";
const options: any = {
  mode: "payment",
  amount:  49900, // £1.00 in pence for testing
  currency: "gbp",
  // Fully customizable with appearance API.
  appearance: {
    /*...*/
  },
};
// const stripePromise = loadStripe(
//   "pk_test_51PvJs8RxhluIEwTyXKt2U8nd0roA1C54ZUEmUMNdzZDUPHp7lo3K142S6AvAsRgaXmRwWZSUv6QCgN21DLDksroe00C6eedfAt"
// ); 
const stripePromise = loadStripe(
  "pk_live_51PvJs8RxhluIEwTy5XTCg8xBKgRGgIoMfX952WIilifATuB0jPNiZJOMIJRTxquPU31cQt2IOGNBson9uDcpXmqN0000jhboRk"
); // TODO: Replace with your Stripe publishable key

export const Checkout = () => {
  return (
    <div className="checkout-page">
      <div className="checkout-main">
        <div className="product-details-section">
          <img src={checkout} alt="Course Banner" className="product-banner" />
          <h1 className="product-title">
            7 Step Guide To Making Viral Social Media Content

          </h1>
          <p className="product-price">
            Get Lifetime Access for only{" "}
            <span className="strikethrough-price">£999</span>{" "}
            <span className="final-price">£499</span>{" "}
            {/* <span className="highlight-text">(SAVE40)</span> */}
          </p>
          {/* Feature list with checkmarks but no bullet dots and without 'Navigate Partnerships with your dream brands' */}
          <div className="product-features" style={{marginBottom: '24px'}}>
            <div>✔️ Create viral-worthy content for TikTok & Reels</div>
            <div>✔️ Master the TikTok/Reels Algorithm</div>
            <div>✔️ Find a Repeatable Format to break 100k views every time</div>
            <div>✔️ Establish a Video Editing Workflow</div>
            <div>✔️ Organically Reach the most people POSSIBLE with your content</div>
            <div>✔️ Optimize every video you post to TikTok, Reels or YouTube Shorts</div>
          </div>
          <div className="guarantee-box">
            <h3 className="guarantee-title">Our 100% Money Back Guarantee:</h3>
            <p className="guarantee-text">
              If you don't get 1,000,000 views in your first three months after putting this course into practice, we'll give you a full refund, no questions asked.
            </p>
          </div>
        </div>

        <div className="checkout-form-section">
          <div className="checkout-form-container">
            <div className="price-summary">
              <span className="strikethrough-price">£999.00</span>
              <span className="final-price">£499</span>
            </div>
            <Elements stripe={stripePromise} options={options}>
              <StripeCheckoutForm />
            </Elements>
          </div>
        </div>
      </div>
    </div>
  );
};
